export default __webpack_public_path__ + "static/media/adhem.6a6de097.png";